const req = require.context('./helpers', true, /\.js$/);

const utils = {};

req.keys().forEach((key) => {
    utils[key.replace(/^[^\w]+(\w+)[^\w]+.+$/, "$1")] = req(key).default;
});

export default utils;

